import PropTypes from 'prop-types';
import AccessDenied from 'pages/accessDenied/AccessDenied';
import React from 'react';
import AdsProduct from './adsProduct/AdsProduct';
import CollapsableCard from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import Body from 'commons/card/Body';

export default function ReportFactory(props) {
  let component;
  switch (props.report) {
    case 'Produits-Annonces':
      component = <AdsProduct report={props.report} />;
      break;
    default:
      component = <AccessDenied />;
  }

  return <CollapsableCard canCollapse={false} type="info" style={{ backgroudColor: 'white' }}>
    <Header title={props.report}/>
    <Body>{component}</Body>
  </CollapsableCard>;
}

ReportFactory.propTypes = {
  report: PropTypes.string,
};
